import mutationTypes from './mutation-types'

export default {
  [mutationTypes.SET_REQUIRED] (state, payload) {
    state.required = payload;
  },
  [mutationTypes.SET_ANALYTICS] (state, payload) {
    state.analytics = payload;
  },
  [mutationTypes.SET_MARKETING] (state, payload) {
    state.marketing = payload;
  },
  [mutationTypes.SET_FACEBOOK_PIXEL] (state, payload) {
    state.facebookPixel = payload;
  },
  [mutationTypes.SET_ACCEPT_ALL_URL] (state, payload) {
    state.acceptAllUrl = payload;
  },
  [mutationTypes.SET_ACCEPT_SELECTED_URL] (state, payload) {
    state.acceptSelectedUrl = payload;
  },
}
